export enum AddressType {
  SHIPPING = 'shipping',
  BILLING = 'billing',
}

export const addressTypes = [AddressType.SHIPPING, AddressType.BILLING];
